import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { NegotiationProvider } from './context/NegotiationProvider';

import './assets/css/stylesheet.css';
import './assets/css/login.css';
import './assets/css/custom.css';
import './assets/css/sleeve.css';

// React Helmet (optional)
import { HelmetProvider, Helmet } from 'react-helmet-async';

// React Query
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

// Create Query Client
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider client={queryClient}>
    <NegotiationProvider>
      <Router>
        <App />
      </Router>
    </NegotiationProvider>
  </QueryClientProvider>
);

reportWebVitals();
